import { render } from "./OurStory.vue?vue&type=template&id=0835d924&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=js"
export * from "./OurStory.vue?vue&type=script&lang=js"

import "./OurStory.vue?vue&type=style&index=0&id=0835d924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0835d924"]])

export default __exports__